import React from 'react'
import styles from './styles.module.scss'
import Avatar from 'srcReact/components/common2/Avatar'
import AnchorLink from 'srcReact/components/common2/AnchorLink'

const ActiveGroupItem = ({
  groupId,
  groupName,
  userName,
  value,
  organizerPicture,
  groupCover,
  mimeType,
  originalTag,
  isOriginal
}) => {
  return (
    <AnchorLink className={styles.activeGroup} path={`/0/home/group/${groupId}`} isReactLink={true}>
      <div
        className={`${styles.groupPicture} ${groupCover ? null : styles['defaultImage']}`}
        style={
          groupCover
            ? {
                backgroundImage: `url(${groupCover})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover'
              }
            : null
        }
        alt={groupName}
      />
      <div className={styles.groupInfo}>
        <p className={styles.groupName}>{groupName}</p>
        <div className={styles.userInfo}>
          <Avatar
            profilePicture={organizerPicture}
            imgWrapperSize='tiny16'
            mimeType={mimeType}
            originalTag={originalTag}
            isOriginal={isOriginal}
          />
          <div className={styles.userName}>{userName}</div>
        </div>
      </div>
      <div className={styles.value}>{value}</div>
    </AnchorLink>
  )
}

export default ActiveGroupItem
